import { resolveMediaAspectRatio } from './media-aspect-ratio'

interface ResolveWebVideoAspectRatioParams {
  videoWidth: number
  videoHeight: number
  fallbackAspectRatio: number
}

export function resolveWebVideoAspectRatio({
  videoWidth,
  videoHeight,
  fallbackAspectRatio,
}: ResolveWebVideoAspectRatioParams): number {
  return resolveMediaAspectRatio({
    width: videoWidth,
    height: videoHeight,
    isVideo: true,
    isWeb: true,
    fallbackAspectRatio,
  })
}
